/**
 * Shared layout tokens for platform content surfaces (app/collection pages).
 *
 * Intentionally excludes shell chrome (rails, gradient wrappers, etc.).
 * Color values come from Constants so light/dark is decided once at boot.
 */

import Constants from '../../submodules/logictry_config/constants';

/** Mid-tone of the content canvas — use for ClampedText see-more fades */
export const LOGIC_BASE_CANVAS_FADE = Constants.LogicBaseCanvasFade || '#fff';

/** Browse canvas background — flat white or full black */
export const LOGIC_BASE_CANVAS_GRADIENT = Constants.LogicBaseCanvasGradient || '#fff';

/** Mobile fixed header — matches canvas */
export const LOGIC_BASE_HEADER_SCRIM = Constants.LogicBaseHeaderScrim || '#fff';

/** Subtle elevation for floating content cards (no hard border) */
export const LOGIC_BASE_FLOAT_SHADOW = Constants.LogicBaseFloatShadow || '0 1px 2px rgba(0, 0, 0, 0.04), 0 8px 32px rgba(0, 0, 0, 0.07)';

/** Slightly stronger lift for content cards on the main app canvas */
export const LOGIC_BASE_CONTENT_SHADOW = Constants.LogicBaseContentShadow || '0 0 1px rgba(0, 0, 0, 0.05), 0 2px 6px rgba(0, 0, 0, 0.06), 0 6px 16px rgba(0, 0, 0, 0.07)';

/** Stacked (tablet/mobile) content viewport height — matches LogicBaseAppPage ContentViewport min-height. */
const LOGIC_BASE_BOTTOM_CHROME_STACK = '3.65rem';
export const LOGIC_BASE_STACKED_VIEWPORT_HEIGHT = `calc(100svh - 6.5rem - ${LOGIC_BASE_BOTTOM_CHROME_STACK})`;
export const LOGIC_BASE_MOBILE_VIEWPORT_HEIGHT = `calc(100svh - 12rem - ${LOGIC_BASE_BOTTOM_CHROME_STACK})`;
/** Embedded live meeting — shorter card so tiles fill more of the panel on mobile. */
export const LOGIC_BASE_MOBILE_MEETING_VIEWPORT_HEIGHT = `calc(100svh - 10rem - ${LOGIC_BASE_BOTTOM_CHROME_STACK})`;
